import { equals } from '@soltalabs/ramda-extra'
import { memo } from 'react'

function deepMemo(Component) {
  return memo(Component, equals)
}

export { deepMemo }
